import { Box, Theme, Typography } from '@mui/material'
import useStyles from '~/common/hooks/useStyles'
import { DossColor, blue, green, orange, purple, red } from '~/common/styles/colors'

function getStyles(theme: Theme) {
  return {
    chip(color: DossColor) {
      return {
        borderRadius: '2px',
        padding: theme.spacing(0),
        backgroundColor: color[2],
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '2px',
        color: color[9],
      }
    },
  }
}

interface FormulaColumnChipProps {
  name: string
  tableLink?: JSX.Element
  index: number
}

export function FormulaColumnChip({ name, index, tableLink }: FormulaColumnChipProps) {
  const styles = useStyles(getStyles)

  let color: DossColor
  if (index % 5 === 0) {
    color = orange
  } else if (index % 5 === 1) {
    color = purple
  } else if (index % 5 === 2) {
    color = green
  } else if (index % 5 === 3) {
    color = red
  } else {
    color = blue
  }

  return (
    <Box sx={styles.chip(color)}>
      {tableLink}
      <Typography variant="body1">{name}</Typography>
    </Box>
  )
}
